// Logout utility function
export const logout = async () => {
  try {
    // Clear localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userName");

    // Optional: Call logout API endpoint if needed
    // await axiosInstance.post('/logout');

    return true;
  } catch (error) {
    console.error("Logout error:", error);
    // Still clear localStorage even if API call fails
    localStorage.removeItem("token");
    localStorage.removeItem("userRole");
    localStorage.removeItem("userName");
    return true;
  }
};

export default logout;
